import React, { useContext, useEffect, useState } from "react"; 
import { Route, Routes } from "react-router-dom"; // Removed Navigate import
import { BounceLoader } from "react-spinners";
import httpRequest from "../../httpRequest"; // Adjust path as necessary

import LoginPage from "../LoginPage/LoginPage";
import RegisterPage from "../RegisterPage/RegisterPage";
import HistoryPage from "../HistoryPage/HistoryPage";

import MyInvoices from "../MyInvoices/MyInvoices";
import MyExpenses from "../MyExpenses/MyExpenses";
import BulkExpense from "../BulkExpense/BulkExpense";

import AddExpenses from "../AddExpenses/AddExpenses";
import HomePage from "../HomePage/HomePage";
import ScanPage from "../ScanPage/ScanPage";
import GeneralScan from "../GeneralScan/GeneralScan";
import BulkScan from "../BulkScan/BulkScan";

import UsersPage from "../UsersPage/UsersPage";
import SuppliersPage from "../SuppliersPage/SuppliersPage";
import ExpenseReimbursements from "../ExpenseReimbursements/ExpenseReimbursements";
import DocumentManagement from "../DocumentManagement/DocumentManagement";
import SettingsPage from "../SettingsPage/SettingsPage";

import DocumentUpload from "../DocumentUpload/DocumentUpload";
import AuditsPage from "../AuditsPage/AuditsPage";
import ExpenseReimbursementsHistory from "../ExpenseReimbursementsHistory/ExpenseReimbursementsHistory";

import { useStyles } from "./styles";
import UserContext from "../../context/user-context";
import DocumentExtraction from "../DocumentExtraction/DocumentExtraction";
import Merger from "../Merger/Merger"
import OCRScanner from "../OCRScanner/OCRScanner";

const App = () => {
  const classes = useStyles();
  const { setUserData } = useContext(UserContext);
  
  const [loading, setLoading] = useState(true); // State to control loading
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(true); // State to track user login status

  const fetchUserData = async () => {
    try {
      const cachedAvatar = localStorage.getItem("userAvatar");
      const cachedSignature = localStorage.getItem("userSignature");

      // Check if avatar and signature are cached
      const response = await httpRequest.get(
        `${process.env.REACT_APP_BACKEND_URL}/@me${
          cachedAvatar && cachedSignature ? "?exclude_fields=avatar,signature" : ""
        }`
      );

      if (response.data.error === "Unauthorized") {
        // If the response indicates an unauthorized error
        setIsUserLoggedIn(false);
        setUserData(null); // Clear user data in context
      } else {
        setUserData(response.data); // Update UserContext with fetched data
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setIsUserLoggedIn(false); // Set to false if an error occurs
    } finally {
      setLoading(false); // Set loading to false after the request completes
    }
  };

  useEffect(() => {
    fetchUserData(); // Fetch user data on mount
  }, []);

  if (loading) {
    return  <div className={classes.preloader}>
    <BounceLoader
      size={60} // Adjust the size
       color="#427CAC"
      loading={loading}
      speedMultiplier={1.5} // Adjust the speed of the animation
    />
  </div>;
  }

  return (
    <div className={classes.appContainer}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        <Route path="/" element={isUserLoggedIn ? <HomePage /> : <LoginPage />} />
        <Route path="/scan" element={isUserLoggedIn ? <ScanPage /> : <LoginPage />} /> 
        <Route path="/add-expenses" element={isUserLoggedIn ? <AddExpenses /> : <LoginPage />} /> 
        <Route path="/general-scan" element={isUserLoggedIn ? <GeneralScan /> : <LoginPage />} />
        <Route path="/merger" element={isUserLoggedIn ? <Merger /> : <LoginPage />} />
        <Route path="/doc-extraction" element={isUserLoggedIn ? <DocumentExtraction /> : <LoginPage />} />
        <Route path="/ocr-scanner" element={isUserLoggedIn ? <OCRScanner /> : <LoginPage />} />
        <Route path="/bulk-scan" element={isUserLoggedIn ? <BulkScan /> : <LoginPage />} />
        <Route path="/my-invoices" element={isUserLoggedIn ? <MyInvoices /> : <LoginPage />} />
        <Route path="/my-expenses" element={isUserLoggedIn ? <MyExpenses /> : <LoginPage />} />
        <Route path="/bulk-expense" element={isUserLoggedIn ? <BulkExpense /> : <LoginPage />} />
        <Route path="/history" element={isUserLoggedIn ? <HistoryPage /> : <LoginPage />} />
        <Route path="/users" element={isUserLoggedIn ? <UsersPage /> : <LoginPage />} />
        <Route path="/vendors" element={isUserLoggedIn ? <SuppliersPage /> : <LoginPage />} />
        <Route path="/expense-reimbursements" element={isUserLoggedIn ? <ExpenseReimbursements /> : <LoginPage />} />
        <Route path="/expense-reimbursements-history" element={isUserLoggedIn ? <ExpenseReimbursementsHistory /> : <LoginPage />} />
        <Route path="/upload-document" element={isUserLoggedIn ? <DocumentUpload /> : <LoginPage />} />
        <Route path="/drms" element={isUserLoggedIn ? <DocumentManagement /> : <LoginPage />} />
        <Route path="/audits" element={isUserLoggedIn ? <AuditsPage /> : <LoginPage />} />
        <Route path="/settings" element={isUserLoggedIn ? <SettingsPage /> : <LoginPage />} />
      </Routes>
    </div>
  );
};

export default App;
